import React, { EventHandler, useContext, useEffect, useState } from "react";
import "./Indicator.scss";
import { ThemeContext } from "../../store/ThemeProvider";
import { getPendantColor } from "../../utils/color";
import ReactSVG from "react-svg";
import { IOneGallery } from "../GalleryList/Common";
import uColumn2List from "../GalleryList/useColumn2List";
import { debounce } from "../../utils/util";
import intl from "react-intl-universal";
import { PageContext} from "../ComponentNavigatorV2/PageContext";

interface IIndicator {
  total: number;
  mode: string;
  loadedTotal: number;
  // tagRefTop: number;
  // list?: IOneGallery[];
  // top: number;
}

const Index = (props:IIndicator)=>{
  const {total, mode, loadedTotal} = props;

  const { backgroundColor } = useContext(ThemeContext);
  const [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor);
  const [mainWrapper, setMainWrapper] = useState(null as HTMLDivElement | null);
  const [pageTopWrapper, setPageTopWrapper] = useState(null as HTMLDivElement | null);

  const context = useContext(PageContext);
  useEffect(()=>{
    if(context.cid) {
      setMainWrapper(window.document.querySelector('.decorate-container')! as HTMLDivElement);
      setPageTopWrapper(window.document.getElementById(`page-top-${context.cid}`)! as HTMLDivElement);
    }
  }, [context.cid]);

  const scrollToTop = ()=>{
    if(mainWrapper) {
      mainWrapper.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  const [number, setNumber] = useState(-1);
  const [isMoving, setIsMoving] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(()=>{
    const onScroll = ()=>{
      if(mainWrapper && pageTopWrapper) {
        let targetX = mainWrapper.offsetLeft + 50;
        let targetY = pageTopWrapper.offsetHeight + 50;

        const {offsetHeight, scrollHeight, scrollTop} = mainWrapper;

        if((offsetHeight + scrollTop) >= (scrollHeight - 50)) {
          // 此处应该显示的是当前已加载图片的总数
          setNumber(loadedTotal);
        }else {
          let target = window.document.elementFromPoint(targetX, targetY) as HTMLElement;
          if(target) {
            // 查一下
            let index = target.getAttribute('data-index');
            if(Number(index)) {
              setNumber(Number(index));
            }else {
              setNumber(-1);
            }
          }
        }
      }
    };

    

    window.addEventListener(`page-scroll-move-${context.cid}`, onScroll);
    
    return ()=>{
      window.removeEventListener(`page-scroll-move-${context.cid}`, onScroll);
    }
  }, [mainWrapper, pageTopWrapper, isMoving]);

  useEffect(()=>{
    if(number > 0) {
      setShow(true);
    }else {
      setShow(false);
    }
  }, [number]);

  useEffect(()=>{
    let timer = 0;
    if(number > 0) {
      setIsMoving(true);
      timer = window.setTimeout(()=>{
        setIsMoving(false)
      }, 800);
    }

    return ()=>{
      window.clearTimeout(timer);
    }
  }, [number]);

  return show ? (
    <div
      className="gallery-indicator"
      style={{
        color: pendantIconColor,
        backgroundColor: pendantBgColor,
        // top: props.top,
      }}
      onClick={scrollToTop}
    >
      {isMoving ? (
        `${Math.max(1, number)}/${props.total || 0}`
      ) : (
        <>
          <div>{intl.get("To top")}</div>
          <ReactSVG
            src={require("../../svg/double-up-arrow.svg")}
            className={"db-arrow"}
          />
        </>
      )}
    </div>
  ) : null;
}

export default Index;

// export default function (props: Indicator) {
//   // 注意，在从非fixed到fixed的状态下， 该组件的状态会被初始化，所以需要在此时用之前保留的moving状态，否则会出现一瞬间的状态丢失
//   const [isMoving, setIsMoving] = useState(moving);
//   // const [lastTop, setLastTop] = useState(0);
//
//   const { tagRefTop, mode, list } = props;
//   const [num, setNum] = useState(0);
//   const setMove = (move: boolean) => {
//     // 如果重新设置的值和当前的值一样，就没有必要重新设置了，保持即可，只有不一样的时候才设置
//     if (moving !== move) {
//       moving = move;
//       setIsMoving(move);
//     }
//   };
//
//   const getIndexInMode1 = function (delta: number) {
//     let totalHeight = 0;
//     const imgList = document.querySelectorAll(".gallery-list img");
//     const index = Array.prototype.findIndex.call(imgList, function (one) {
//       const { height } = one.dataset;
//       totalHeight += (+height || 0) + MODE1_BORDER_BOTTOM;
//       return totalHeight > delta;
//     });
//     return index + 1;
//   };
//
//   const getIndexInModeTime = (delta: number) => {
//     const galleryDom = window.document.querySelector('.gallery');
//     let target = window.document.elementFromPoint(
//       // @ts-ignore
//       50 + (galleryDom && galleryDom.offsetLeft ? Number(galleryDom.offsetLeft) : 0), // 此处还需要添加 left
//       delta + 50 - lastTop + tagRefTop
//     );
//     if (target) {
//       return Number(target.getAttribute("data-index"));
//     }
//     return 0;
//   };
//
//   const getIndexInMode4 = function (delta: number) {
//     const { clientWidth } = document.documentElement;
//     const actualWidth = clientWidth - 2 * GALLERY_LIST_PADDING;
//     const actualHeight = actualWidth / 4 + 1; // 1px的border bottom
//     const row = Math.ceil(delta / actualHeight);
//     return 4 * (row - 1) + 1;
//   };
//
//   const getIndexInMode2 = function (delta: number) {
//     // 参考AllForColumn2的高度处理
//
//     if (!list) {
//       return 0;
//     }
//     // 为了防止第二列和第一列的看起来异常的排列，直接用第一列作为数据进行处理了，后续有时间再慢慢考虑
//     const { c1Offset } = uColumn2List(list);
//     const c = c1Offset.findIndex((one) => one.height > delta);
//
//     if (c1Offset[c]) {
//       return c1Offset[c].index + 1;
//     }
//     return 0;
//   };
//
//   const setCurrentPositionNumber = function (scrollTop: number) {
//     // typeList的高度是40
//     const delta = scrollTop - tagRefTop - GALLERY_LIST_PADDING;
//     // console.log(scrollTop, tagRefTop);
//     if (delta <= 0) {
//       setNum(0);
//     } else {
//       // console.log(mode)
//       // 根据mode判断当前的情况
//       if (mode === "1") {
//         // console.log(delta);
//         setNum(getIndexInMode1(delta));
//       } else if (mode === "3") {
//         // 4列
//         setNum(getIndexInMode4(delta));
//       } else if (mode === "2") {
//         // 2列
//         setNum(getIndexInMode2(delta));
//       } else if (mode === "4") {
//         // 时间轴
//         setNum(getIndexInModeTime(delta));
//       } else if (mode === "waterfall") {
//         setNum(getIndexInModeTime(delta));
//       } else {
//         console.warn("no such mode", mode);
//       }
//     }
//   };
//
//   // 重写了一下触发时机，让那个“返回顶部”的显示没有那么及时和突兀 - 2019-10-15
//   useEffect(() => {
//     // const tillParent = document.querySelector('.gallery-home')!;
//     const tillParent = window;
//
//     const checkMove = () => {
//       // if (tillParent && tillParent.parentElement) {
//       // const { scrollTop } = tillParent.parentElement;
//       let scrollTop = tillParent.scrollY;
//
//       // 动了
//       if (lastTop !== scrollTop) {
//         lastTop = scrollTop;
//         setMove(true);
//         setCurrentPositionNumber(scrollTop);
//       } else {
//         // 没动
//         setMove(false);
//       }
//       // }
//     };
//
//     const debounceCheckMove = debounce(checkMove, 320, false);
//
//     const realParent = document.querySelector(".gallery-home");
//     const scrollHandler = () => {
//       // if (tillParent && tillParent.parentElement) {
//       // @ts-ignore
//       const { clientHeight } = realParent;
//       // const { scrollTop } = tillParent.parentElement;
//       let scrollTop = window.scrollY;
//       lastTop = scrollTop;
//
//       setMove(true);
//       const MAX_TOLERATE = 20;
//       // 当滚动到底部MAX_TOLERATE像素以内的时候，直接设置成最后一张图片的数量
//       if (
//         scrollTop + document.documentElement.clientHeight >
//         clientHeight - MAX_TOLERATE
//       ) {
//         setNum(list ? list.length : 0);
//       } else {
//         setCurrentPositionNumber(scrollTop);
//       }
//       // }
//
//       debounceCheckMove();
//     };
//
//     window.addEventListener("scroll", scrollHandler);
//
//     return () => {
//       window.removeEventListener("scroll", scrollHandler);
//     };
//
//     //
//     // return () => {
//     //   if (tillParent && tillParent.parentElement)
//     //     tillParent.parentElement.removeEventListener('scroll', scrollHandler);
//     // };
//
//     // 注意，因为setCurrentPositionNumber 调用了tagRefTop/mode，必须将其设置成依赖，否则可能不会更新
//   }, [tagRefTop, mode, list]);
//   useEffect(() => {
//     return () => {
//       if (once === false) {
//         once = true;
//         console.log(
//           "因为debounce的setTimeout无法被取消，所以这个组件在卸载的时候会有一个警告，请无视掉"
//         );
//       }
//     };
//   }, []);
//
//   const scrollToTop = () => {
//     // const tillParent = document.querySelector('.gallery-home')!;
//     //
//     // if (tillParent && tillParent.parentElement) {
//     //   tillParent.parentElement.scrollTo({
//     //     top: 0,
//     //     left: 0,
//     //     behavior: 'smooth'
//     //   });
//     // }
//     window.scrollTo({
//       top: 0,
//       left: 0,
//       behavior: "smooth",
//     });
//   };
//
//   const { backgroundColor } = useContext(ThemeContext);
//   const [pendantBgColor, pendantIconColor] = getPendantColor(backgroundColor);
//
//   return lastTop > tagRefTop && Number(props.total) > 0 ? (
//     <div
//       className="gallery-indicator"
//       style={{
//         color: pendantIconColor,
//         backgroundColor: pendantBgColor,
//         bottom: props.bottom,
//       }}
//       onClick={scrollToTop}
//     >
//       {isMoving ? (
//         `${Math.max(1, num)}/${props.total || 0}`
//       ) : (
//         <>
//           <div>{intl.get("To top")}</div>
//           <ReactSVG
//             src={require("../../svg/double-up-arrow.svg")}
//             className={"db-arrow"}
//           />
//         </>
//       )}
//     </div>
//   ) : null;
// }
